module.exports = __webpack_public_path__ + "img/2.e363b186.jpg";